<!--
 * @Author: jjchen
 * @Date: 2022-08-15 11:24:57
 * @LastEditors: jjchen
 * @LastEditTime: 2022-08-30 11:52:43
 * @Description: 
-->
<template>
  <canvas id="canvas" v-show="isShow"></canvas>
</template>
<script>
const SCALE = 2
export default {
  props: {
    radarData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      data: [],
      isShow: false,
    }
  },
  mounted() {
    setTimeout(() => {
      this.data = JSON.parse(JSON.stringify(this.radarData))
      this.init()
    }, 800)
  },
  methods: {
    init() {
      // 创建一个400*300的画布
      let canvas = document.getElementById('canvas')
      canvas.width = 360 * SCALE
      canvas.height = 260 * SCALE
      let ctx = canvas.getContext('2d')
      let count = 4
      let result = []
      let begin = this.data.splice(0, 2)
      begin.forEach((item) => {
        result.push(((48 * SCALE) / 30) * item)
      })
      this.data.forEach((item) => {
        result.push(((48 * SCALE) / 20) * item)
      })
      let secondScore = result.splice(1, 1)
      result.push(secondScore[0])
      let specials = result // 绘制的四数值的位置

      // 绘制底层网格 4格子
      for (let j = 0; j <= 3; j++) {
        ctx.beginPath()
        for (let i = 0; i < count; i++) {
          ctx.strokeStyle = 'rgba(65, 97, 128, 0.4500)' // 网格颜色
          let r = j * 16 * SCALE // 一小格15
          let deg = (((i / count) * 360 - 45) * Math.PI) / 180
          let x = r * Math.sin(deg) + r * Math.cos(deg) + 180 * SCALE
          let y = r * Math.sin(deg) - r * Math.cos(deg) + 130 * SCALE
          ctx.lineTo(x, y)
        }
        ctx.closePath()
        ctx.stroke()
      }
      // 绘制经线
      ctx.beginPath()
      for (let i = 0; i < count; i++) {
        ctx.moveTo(180 * SCALE, 130 * SCALE)
        let r = 48 * SCALE //60
        let deg = (((i * 360) / count - 45) * Math.PI) / 180
        let x = r * Math.sin(deg) + r * Math.cos(deg) + 180 * SCALE
        let y = r * Math.sin(deg) - r * Math.cos(deg) + 130 * SCALE
        ctx.lineTo(x, y)
      }
      ctx.stroke()

      // 绘制四个点的坐标含义
      ctx.fillStyle = '#356eff'
      ctx.font = '24px Calibri'
      ctx.fillText('核心知识产权能力', 132 * SCALE, 42 * SCALE)
      ctx.fillText('科技成果转化能力', 4 * SCALE, 133 * SCALE)
      ctx.fillText('经营成长性能力', 262 * SCALE, 133 * SCALE)
      ctx.fillText('研发组织管理能力', 132 * SCALE, 225 * SCALE)

      // 绘制里面的图形
      ctx.beginPath()
      ctx.lineWidth = 2
      ctx.strokeStyle = 'rgba(91, 143, 249, 1)'
      for (let i = 0; i < specials.length; i++) {
        let r = specials[i]
        let deg = (((i * 360) / count - 45) * Math.PI) / 180
        let x = r * Math.sin(deg) + r * Math.cos(deg) + 180 * SCALE
        let y = r * Math.sin(deg) - r * Math.cos(deg) + 130 * SCALE
        ctx.lineTo(x, y)
      }
      ctx.closePath()
      ctx.fillStyle = 'rgba(91, 143, 249, 0.2500)'
      ctx.fill()
      ctx.stroke()
      canvas.style.transform = 'scale(0.5)'
      this.isShow = true
    },
  },
}
</script>
